export default __webpack_public_path__ + "static/media/feature1.0d6c20df.png";